import React, {useState} from "react";
import "./qualification.css"
export default function Qualification(){
    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
        setToggleState(index);
    };
    return (
        <section className="qualification section" id="portfolio">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>
            <div className="qualification__container container">
                <div className="qualification__tabs">

                    <div className={
                                    toggleState === 1
                                    ? "qualification__button qualification__active button--flex"
                                    : "qualification__button  button--flex"
                                }
                                onClick={() => toggleTab(1)}
                            >
                        <i class="uil uil-file-shield-alt qualification__icon"></i> Project
                    </div>

                    <div className={
                                    toggleState === 3
                                    ? "qualification__button qualification__active button--flex"
                                    : "qualification__button  button--flex"
                                }
                                onClick={() => toggleTab(3)}
                            >
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>

                    <div className={
                                    toggleState === 2
                                    ? "qualification__button qualification__active button--flex"
                                    : "qualification__button  button--flex"
                                }
                                onClick={() => toggleTab(2)}
                            >
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>


                </div>
                <div className="qualification__sections">
                    
                    
                    <div className={
                                toggleState === 1
                                ? "qualification__content qualification__content-active"
                                : "qualification__content"
                            }

                        >
                        
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Roll The Dice</h3>
                                <span className="qualification__subtitle">HTML, CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jan 3, 2022
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
    
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Snake Game</h3>
                                <span className="qualification__subtitle">HTML, CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jan 3, 2022
                                </div>
                            </div>
                        </div>

                     
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Pakman Game</h3>
                                <span className="qualification__subtitle">HTML, CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jan 17, 2022
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Type Speed Game</h3>
                                <span className="qualification__subtitle">HTML, CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jan 20, 2022
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Profile Website</h3>
                                <span className="qualification__subtitle">HTML,CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Apr 2, 2021
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Barbar Website</h3>
                                <span className="qualification__subtitle">HTML, CSS, Javascript</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Feb 3, 2022
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Movies</h3>    
                                <span className="qualification__subtitle">ReactJs</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Feb 3, 2023
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Movies</h3>
                                <span className="qualification__subtitle">NodeJs</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Mar 18, 2022
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">NerkhNava_Bot</h3>    
                                <span className="qualification__subtitle">NodeJs</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Apr 10, 2023
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Website</h3>
                                <span className="qualification__subtitle">Php</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> May 13, 2023
                                </div>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Website</h3>    
                                <span className="qualification__subtitle">Laravel</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jun 29, 2023
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Healtcare</h3>
                                <span className="qualification__subtitle">Andoride</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Jun 11, 2023
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Admin</h3>    
                                <span className="qualification__subtitle">Filament_Laravel</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> Aug 1, 2023
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Api_Base</h3>
                                <span className="qualification__subtitle">Laravel</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> In Progress
                                </div>
                            </div>
                        </div>


                    </div>
                    
                    
                    <div className={
                                toggleState === 3
                                ? "qualification__content qualification__content-active"
                                : "qualification__content"
                            }>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Kabul Polytechnic University</h3>
                                <span className="qualification__subtitle">Bacholar of Computer Science</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 11/2021 - 2/2022
                                </div>
                            </div>
                           
                        </div>
                                
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">ICPC  12th-position</h3>
                                <span className="qualification__subtitle">Programming Contest</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 11/2021 - 2/2022
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Scrimba</h3>
                                <span className="qualification__subtitle">Frontend career path</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 11/2021 - 2/2022
                                </div>
                            </div>
                           
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">ICDL</h3>
                                <span className="qualification__subtitle">Database</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 11/2022 - 12/2022
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                           <div></div>
                           <div>
                               <span className="qualification__rounder"></span>
                               <span className="qualification__line"></span>
                           </div>
                           <div>
                               <h3 className="qualification__title">FreeCodeCamp</h3>
                               <span className="qualification__subtitle">Javascript Algorithms and Data Structuers</span>
                               <div className="qualification___calender">
                                   <i className="uil uil-calendar-alt"></i> 200 hours of coursework
                               </div>
                           </div>    
                       </div>

                       <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">FreeCodeCamp</h3>
                                <span className="qualification__subtitle">Responsive Web Design</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 200 hours of coursework
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                    </div>

                    
                    <div className={
                                toggleState === 2
                                ? "qualification__content qualification__content-active"
                                : "qualification__content"
                            }>
                        
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Software Developer</h3>
                                <span className="qualification__subtitle">Hamsenfi ICT</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 2020 - 2021
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Web Dsigner</h3>
                                <span className="qualification__subtitle">Figma</span>
                                <div className="qualification___calender">
                                    <i className="uil uil-calendar-alt"></i> 2021 - 2022
                                </div>
                            </div>
                           
                        </div>

                    </div>


                </div>
            </div>
        </section>
    )
}